// StyledCheckbox.js
import styled from "styled-components";

const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  opacity: 0;
  position: absolute;

  & + label {
    display: inline-block;
    vertical-align: middle;
    margin: 5px;
    cursor: pointer;
    width: fit-content;
    display: flex !important;
    position: relative;
    margin-left: 0px !important;
    align-items: center;

    &:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      padding: 0px;
      margin-right: 10px;
      border-style: solid;
      font-size: ${({ styling }) => `${styling.checkboxInputSize - 3}px`};
      width: ${({ styling }) => `${styling.checkboxInputSize}px`};
      height: ${({ styling }) => `${styling.checkboxInputSize}px`};
      border-color: ${({ styling }) => styling.checkboxUncheckedBorderColor};
      border-width: ${({ styling }) => `${styling.checkboxBorderWidth}px`};
      background: ${({ styling }) => styling.checkboxUncheckedBackgroundColor};
      border-radius: ${({ styling }) => `${styling.checkboxBorderRadius}px`};
      transition: ${(props) => props.theme.transitionMain};
    }
  }

  &:checked + label:before {
    content: ${({ styling }) =>
      styling.checkedCheckboxContent === "✔" ? `'✔'` : ''};

    background: ${({ styling }) => styling.checkboxCheckedBackgroundColor};
    color: ${({ styling }) => styling.checkboxCheckedColor};
    border-color: ${({ styling }) => styling.checkboxCheckedBorderColor};
  }
`;

export default StyledCheckbox;
